module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA6klEQVRYhe2SPwrCMBjFX9M/IkUcnLr0LI4FTyA4CcUriXVw6+QoeAhv4KQ3kOIibeNiQApNSUnyLXnTGwLfj5efd3vsfRCGUR53AA4AAALbB8vPal7xOAWAmfd+WgeoeJxyIBTd+heI46KTO+AAjEjYNX0dXV59b40sIEznQChArAJ0TbcOoBJygNESqogmy+gFVEQzAqAimhEAXSEHkEp4uG+yOmQFJhx+VOe7RXnVDSBdoOF+ASABkPy69gx9QdLTtSU4nrdZE7ACEcCmdZ4vT9pnloU17d/MrZmZpQCwMPMQAGkcADnAFy6MSotb86o7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/NB/second_signal_2.png
// module id = L9+L
// module chunks = 1